export const UPDATE_SECTION_WIDTH = 'UPDATE_SECTION_WIDTH';

export const updateSectionWidth = (width: number) => {
  return {
    type: UPDATE_SECTION_WIDTH,
    data: width,
  };
};
